import { type FunctionComponent, type ReactNode } from "react";

import DesktopTitle from "../DesktopTitle";
import HeaderTitle, { type HeaderTitleProps } from "../HeaderTitle";

type PageTitleProps = Pick<HeaderTitleProps, "hideBackButton"> & {
  children?: ReactNode;
};

const PageTitle: FunctionComponent<PageTitleProps> = ({
  hideBackButton = false,
  children,
}) => {
  return (
    <>
      <HeaderTitle hideBackButton={hideBackButton}>{children}</HeaderTitle>
      <DesktopTitle>{children}</DesktopTitle>
    </>
  );
};

export default PageTitle;
